<template>
  <section class="generic">
    <GenericBoxHeader>
      <slot name="header" />
    </GenericBoxHeader>

    <div class="generic__body">
      <slot />
    </div>
  </section>
</template>

<script>
  import GenericBoxHeader from './GenericBoxHeader'

  export default {
    components: {
      GenericBoxHeader,
    }
  }
</script>

<style scoped lang="scss">
  .generic {
    &__body { padding: 15px 20px }
  }
</style>